"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Piece_1 = require("~/chess/Piece");
const store_1 = require("~/front/store");
const jquery_1 = __importDefault(require("jquery"));
let Piece = class Piece extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.game = store_1.store.state.game;
    }
    get color() {
        return Piece_1.Color[this.piece.color];
    }
    get name() {
        return Piece_1.PieceName[this.piece.name];
    }
    availableMoves() {
        if (this.piece.color == this.game.currentTurn && this.game.isCheckMate === false) {
            this.clearMoves();
            const availableMoves = this.piece.availableMoves(this.game.board);
            availableMoves.forEach(move => {
                document.getElementById(move).classList.add('available-move');
            });
            this.makeAvailableMovesInteractive();
        }
    }
    makeAvailableMovesInteractive() {
        const self = this;
        jquery_1.default('#board').off('click', '.available-move');
        jquery_1.default('#board').on('click', '.available-move', function (e) {
            e.stopImmediatePropagation();
            const destination = jquery_1.default(this).attr('id');
            store_1.store.commit('move', { piece: self.piece, destination });
            self.clearMoves();
        });
    }
    clearMoves() {
        for (const position in store_1.store.state.game.board) {
            document.getElementById(position).classList.remove('available-move');
        }
    }
};
Piece = __decorate([
    vue_property_decorator_1.Component
], Piece);
exports.default = Piece;
